import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createHttpHeaderWithAuthorization } from "../../store/services/http-header";
import { FormattedMessage } from "react-intl";
import axios from "axios";
import "./style.css";

const AttachmentEInvoice = props => {
  const {
    auth,
    detailsDocument: {
      info: { details }
    }
  } = props;

  const downloadIt = element => {
    let request = {
      method: "GET",
      url: element.Attachment,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    axios(request).then(file => {
      var a = document.createElement("a");
      a.href =
        "data:application/octet-stream;charset=utf-8;base64," + file.data;
      a.setAttribute("download", element.NomeAttachment);
      a.click();
    });
  };

  const renderIconFileFA = extension => {
    let imageFAString = "";
    switch (extension) {
    case "jpg":
    case "png":
    case "jpeg":
    case "gif":
      imageFAString = "file-image";
      break;
    case "pdf":
      imageFAString = "file-pdf";
      break;
    case "csv":
      imageFAString = "file-csv";
      break;
    case "xml":
      imageFAString = "file-code";
      break;
    case "xls":
    case "xlsx":
      imageFAString = "file-excel";
      break;
    case "doc":
    case "docX":
      imageFAString = "file-word";
      break;
    default:
      imageFAString = "file";
      break;
    }
    return imageFAString;
  };
  return details &&
    details.einvoiceAttachments &&
    details.einvoiceAttachments.length > 0 ? (
      <div className="borderSeparatorSection noBorder">
        {details.einvoiceAttachments.map((elem, index) => {
          return (
            <div
              key={`einvoiceAttachments_${index}`}
              className="attachmentEntryBorder"
              onClick={e => {
                downloadIt({
                  NomeAttachment: elem.name,
                  FormatoAttachment: elem.format,
                  Attachment: elem.links[0].href
                });
              }}
            >
              <div style={{ display: "inline-block" }}>
                <FontAwesomeIcon
                  icon={["far", renderIconFileFA(elem.format)]}
                  style={{
                    fontSize: "18px",
                    marginRight: "8px",
                    color: "rgb(21, 41, 53)"
                  }}
                />{" "}
                <span className="attachmentName">{elem.name}</span>
                <br />
                <span style={{ fontSize: "14px", fontWeight: 300 }}>
                  {elem.description}
                </span>
              </div>
              <div style={{ float: "right" }}>
                <FontAwesomeIcon
                  icon={["far", "arrow-to-bottom"]}
                  style={{
                    fontSize: "18px",
                    color: "#0090d1"
                  }}
                />{" "}
              </div>
            </div>
          );
        })}
      </div>
    ) : (
      <span>
        <FormattedMessage id="documents.detail.attachmentEmpty" />
      </span>
    );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    detailsDocument: state.detailsDocument
  };
}

export default connect(mapStateToProps, null)(AttachmentEInvoice);
